export const styles = {
  wrapper: {
    padding: '24px',
    border: 'none',
  },
};
